import React from "react";
import {Button,Slider,withStyles,TextField} from "@material-ui/core";
import ReactAvatarEditor from 'react-avatar-editor';
import { faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import GridContainer from '../../components/Grid/GridContainer';
import GridItem from "../../components/Grid/GridItem";
import editimage from '../../assets/images/patientsFilter.png';

const styles = theme => ({
  createUser: {display:'inline-block', height: "40px", margin: "20px 0", textAlign:'center', backgroundColor: "#2262bf", color: "white",
 paddingTop: "12px", width:'200px', paddingBottom: "30px", fontSize: "13.7px", whiteSpace: "nowrap", cursor: "pointer", borderRadius: "50px",
 [theme.breakpoints.down("sm")]: { fontSize: '12px', minWidth: "120px" }, '&:hover': { opacity:'0.8', transition:'0.2s' , backgroundColor:'#2262bf'}
  },
  file:{
    border: "1px solid #ccc",
    display: "inline-block",
    padding: "6px 12px",
    cursor: "pointer"
  },
  primaryBtn: {
        color: "white",
        backgroundColor: "#2262bf",
        textTransform: "capitalize",
        border: "1px solid " +  "#2262bf",
        borderRadius: "50px",
        textAlign: "right",
        padding: "4px 15px",
        marginLeft: "7px",
        '&:hover': {
            backgroundColor:  "#2262bf",
            color:"white",
            border: "1px solid " +  "#2262bf",
        }
    },
});
class Avatar extends React.Component {
  state = {
    image:'',
    allowZoomOut: false,
    position: { x: 0.5, y: 0.5 },
    scale: 0.5,
    scale1: 0,
    rotate: 0,
    slidervalue:0,
    //borderRadius: 0,
    preview: null,
    width: 150,
    height: 150,
  SUPPORTED_FORMATS :["image/jpg","image/jpeg"],
 errorText:'',
imagesize:2097152,
ninty:90,
  };

  handleNewImage = e => {
    if(this.state.SUPPORTED_FORMATS.includes(e.target.files[0].type)&&e.target.files[0].size<this.state.imagesize){
    this.setState({ image: e.target.files[0], errorText:''});
    this.props.setTexts(e.target.files[0],this.props.keyid);
    } else if(e.target.files[0].size>this.state.imagesize){
       this.setState({ image:editimage,errorText:"File Size is greater than 2MB"});
       this.props.setTexts(' ',this.props.keyid);
    } else{
       this.setState({image:editimage,errorText:"Unsupported Format"});
       this.props.setTexts(' ',this.props.keyid);
    }
  };
arial=(value)=>{
return value;
};
  handleScale = (e,newvalue) => {
    const scale = parseFloat(newvalue);
    this.setState({ scale });
this.setState({slidervalue:newvalue});
  };
  handleScale1 = e => {
    const scale1 = parseFloat(e.target.value);
    this.setState({ scale1 });
  };

  handlePositionChange = position => {
    this.setState({ position });
  };
  async componentDidMount() {
    if(this.props.text.url ===""&&this.props.text.value ===" "){
  this.setState({ image:editimage });
} else if (this.props.text.url !== "") {
      this.setState({ image: this.props.text.url });
    }else{
      this.setState({ image: this.props.text.value });
    }
  }
   rotateLeft = () => {
      this.setState({rotate:this.state.rotate - this.state.ninty});
    };
     rotateRight = () => {
        this.setState({rotate:this.state.rotate + this.state.ninty});
    };
  render() {
    const { classes } = this.props;
    return (
      <div style={{marginTop:'20px'}}>
        <Card variant="outlined">
          <CardContent>
            <div>
              <Button size="small" onClick={() => this.props.handleDeletetext(this.props.text.id)} style={{ float: "right"}} >
                <FontAwesomeIcon icon={faTrashAlt} style={{ fontSize: "14px", color: "red" }} />
              </Button>
              < GridContainer>
                <GridItem xs={6}>
                  <ReactAvatarEditor
                    scale={parseFloat(this.state.scale)}
                    width={this.state.width}
                    height={this.state.height}
                    position={this.state.position}
                    onPositionChange={this.handlePositionChange}
                    rotate={parseFloat(this.state.rotate)}
                    border={0}
                    style={{backgroundColor:"rgba(199, 225, 241, 0.1)"}}
                    //borderRadius={parseFloat(this.state.scale1) * 10}
                    image={this.state.image}
                    className="editor-canvas"
                  />
                  <br />
                </GridItem>
                <GridItem xs={6}>
                  <div style={{ display: "flex" }}>
                    <div>
                    <label htmlFor="file-upload" className={classes.createUser}> Browse Image </label>
                    <TextField
                      className={classes.file}
                      style={{ position: "absolute", top: 0, left: 0, opacity: 0, width: "100px", height: "20px" }}
                      autoFocus
                      name={this.props.textid}
                      type="file"
                      id="imagename"
                      inputProps={{accept:"image/jpeg,image/jpg,image/png"}}
                      onChange={this.handleNewImage}
                    />
                    </div>
                  </div>
                  <b style={{color:"#2262bf"}}>{"ROTATE"}</b>: <span><Button onClick={this.rotateLeft} className={classes.primaryBtn} >{"LEFT"}</Button>
                <Button className={classes.primaryBtn} onClick={this.rotateRight}>{"RIGHT"}</Button></span><br /><br />
                <b style={{color:"#2262bf"}}>{"ZOOM"}</b>: <Slider onChange={this.handleScale} value={this.state.slidervalue}
                aria-label="custom thumb label" getAriaValueText={this.arial} defaultValue={0.5} max={4} min={0.5} step={0.1}/>
                  <br />
                   <p style={{color:"#f44336",fontSize:" 0.75rem",paddingTop:"3px"}}>{this.state.errorText}</p>
                </GridItem>
              </GridContainer>
            </div>
          </CardContent>
        </Card>
      </div>

    );
  }
}
export default (withStyles(styles)((Avatar)));